import { useMemo } from 'react';
import { CartItem } from '../../types/cart';
import AnimatedImage from 'core-lib/components/AnimatedImage';
import s from './StackImages.module.scss';

type StackImagesProp = {
  cartData: CartItem[];
  size?: 'small' | 'large';
};

export const StackImages = ({ cartData, size = 'small' }: StackImagesProp) => {

  const data = useMemo(() => {
    const slicedArray = cartData?.slice(-4);
    return slicedArray;
  }, [cartData]);

  const getRootStyle = () => {
    const style = {
      width: `${35 + (data?.length ? Math.min(data.length, 5) : 1) * 4}px`,
    };
    return style;
  };

  const getItemStyle = (index) => {
    const style = {
      left: `${5 * (index + 1)}px`,
      zIndex: `${index}`,
      width: 39,
      height: 39,
    };
    if (size === 'large') {
      style.height = 48;
      style.width = 48;
    }
    return style;
  };

  return (
    <div className={s.root} style={getRootStyle()}>
      {data?.map((item, index) => (
        <div
          key={item?.productId}
          className={s.item}
          style={getItemStyle(index)}
        >
          {index === data.length - 1 && <AnimatedImage src={item?.coverImage} />}
        </div>
      ))}
    </div>
  );
};
